import React, { Component } from "react";
import Nav from 'react-bootstrap/Nav'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Image from 'react-bootstrap/Image'
import Figure from 'react-bootstrap/Figure'
import houseIcon from './../content/img/house.png';
import financeOptionIconSet from './../content/img/financeoptionsicons-2.png'
 
class SliderComponent extends Component {

  render() {
    return (
        <>
            <h2 className="text-center mt-5 mb-4" style={{fontSize: "24px"}}><Image src={houseIcon} className="mr-3" alt="Emlak Katılım Logo" width="38" /> Finansman Seçenekleri</h2>
            <Row>
                <Col  lg={{ span: 8, offset: 2 }}>
                    <p className="text-center mb-5">Siz de hayallerinizi süsleyen bir eve sahip olmak istiyorsanız, artık bu hayalinizi ertelemeyin!<br />Uygun Finansman Seçenekleriyle Hayalinizdeki Ev Emlak Katılım'da!</p>
                </Col>
            </Row>
            <Row>
                <Col lg={{ span: 8, offset: 2 }}>
                    <Row>
                        <Col xs={6} lg>
                            <Nav.Link href="/konut-finansman-urunlerimiz/yeni-evini-bekletmeyen-konut-finansmani">
                                <Figure>
                                    <div className="imageContainer">
                                        <Figure.Caption
                                            width={56}
                                            height={72}
                                            title="Yeni Evini Bekletmeyen Mortgage"
                                            style={{backgroundImage: "url(" + financeOptionIconSet + ")",
                                                    backgroundPositionX: "0px",
                                                    width: "85px"
                                                    }}>
                                        </Figure.Caption>
                                    </div>
                                    <Figure.Caption>
                                    Yeni Evini Bekletmeyen Mortgage
                                    </Figure.Caption>
                                </Figure>
                            </Nav.Link>
                        </Col>
                        <Col xs={6} lg>
                            <Nav.Link href="/konut-finansman-urunlerimiz/konut-finansmani">
                                <Figure>
                                    <div className="imageContainer">
                                        <Figure.Caption
                                            width={56}
                                            height={72}
                                            title="Konut Finansmanı"
                                            style={{ backgroundImage: "url(" + financeOptionIconSet + ")",
                                                backgroundPositionX: "-151px",
                                                width: "56px" }}>
                                        </Figure.Caption>
                                    </div>
                                    <Figure.Caption>
                                    Konut Finansmanı
                                    </Figure.Caption>
                                </Figure>
                            </Nav.Link>
                        </Col>
                        <Col xs={6} lg>
                            <Nav.Link href="/konut-finansman-urunlerimiz/kentsel-donusum">
                                <Figure>
                                    <div className="imageContainer">
                                        <Figure.Caption
                                            width={56}
                                            height={72}
                                            title="Kentsel Dönüşüm"
                                            style={{backgroundImage: "url("+financeOptionIconSet + ")",
                                                backgroundPositionX: "-290px",
                                                width: "76px"
                                                }}>
                                        </Figure.Caption>
                                    </div>
                                    <Figure.Caption>
                                    Kentsel Dönüşüm
                                    </Figure.Caption>
                                </Figure>
                            </Nav.Link>
                        </Col>
                       
                    </Row>
                </Col>
                <Col lg={{ span: 8, offset: 2 }}>
                    <Row>
                    
                        <Col xs={6} lg>
                            <Nav.Link href="/konut-finansman-urunlerimiz/birlikte-konut-finansmani">
                                <Figure>
                                    <div className="imageContainer">
                                        <Figure.Caption
                                            width={56}
                                            height={72}
                                            title="Birlikte Konut Finansmanı"
                                            style={{backgroundImage: "url("+financeOptionIconSet + ")",
                                                backgroundPositionX: "-443px",
                                                width: "70px"
                                                }}>
                                        </Figure.Caption>
                                    </div>
                                    <Figure.Caption>
                                    Birlikte Konut Finansmanı
                                    </Figure.Caption>
                                </Figure>
                            </Nav.Link>
                        </Col>
                        <Col xs={6} lg>
                            <Nav.Link href="/konut-finansman-urunlerimiz/memlekette-konut-finansmani">
                                <Figure>
                                    <div className="imageContainer">
                                        <Figure.Caption
                                            width={56}
                                            height={72}
                                            title="Memlekette Konut Finansmanı"
                                            style={{backgroundImage: "url("+financeOptionIconSet + ")",
                                                backgroundPositionX: "-552px",
                                                width: "88px"
                                                }}>
                                        </Figure.Caption>
                                    </div>
                                    <Figure.Caption>
                                    Memlekette Konut Finansmanı
                                    </Figure.Caption>
                                </Figure>
                            </Nav.Link>
                        </Col>
                        <Col xs={6} lg>
                            <Nav.Link href="/konut-finansman-urunlerimiz/yabanci-yatirimcilar-icin-vatandaslik">
                                <Figure>
                                    <div className="imageContainer">
                                        <Figure.Caption
                                            width={56}
                                            height={72}
                                            title="Yabancı Yatırımcılar için Vatandaşlık"
                                            style={{backgroundImage: "url("+financeOptionIconSet + ")",
                                                backgroundPositionX: "-680px",
                                                width: "66px"
                                                }}>
                                        </Figure.Caption>
                                    </div>
                                    <Figure.Caption>
                                    Yabancı Yatırımcılar için Vatandaşlık                                    </Figure.Caption>
                                </Figure>
                            </Nav.Link>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    );
  }
}
 
export default SliderComponent;